<template>
<div class="login_page">
    <div class="login_carousel">
      <div class="Carousel_img">
        <swiper  :options="swiperOptions" v-if="adList.length>1">
          <swiper-slide v-for="(item,index) in adList" :key="index"><img :src="globalConfig.imgUrl+item.picture_web"/></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div v-if="adList.length>0 && adList.length===1" v-for="(item,index) in adList"><img :src="globalConfig.imgUrl+item.picture_web"/></div>
      </div>

      <div class="login-box">
        <div class="login_title">
          <langs :name="this.$route.name"></langs>
        </div>
        <div class="login-from">
          <div class="form-control">
            <span>{{$t('login.name')}}</span>
            <input type="text" :placeholder="$t('login.name')" v-model="value2Computed" tabindex="1"/>
            <div class="remember">
              <input type="checkbox" :checked="isCheck" @click.stop="_select($event)"/>
              <span class="remember-tip" v-if="isCheck">{{$t('login.remember')}}</span>
            </div>
          </div>
          <div class="form-control">
            <span>{{$t('login.pws')}}</span>
            <input :type="inputtype" :placeholder="$t('login.pws')" v-model="password" tabindex="2"/>
            <div class="eye" @click.stop="_eye"><img src="../assets/img/eye2.png" v-if="inputtype=='text'"/><img src="../assets/img/eye1.png" v-else/></div>
          </div>
        </div>
        <div class="login_btn" @click.stop="_login" @keyup.enter="_login">{{$t('login.submit')}}</div>
      </div>



      <div class="logo"><img :src="this.globalConfig.imgUrl+logo"/></div>

    </div>

  <div class="login_jack" v-if="jack_list.length>0">
    <div class="login_jack-top"></div>
    <div class="login-jack-list" :class="{'jack-top':index==0}" v-for="(item,index) in jack_list">
      <div class="login-jack-center">
        <div class="login-jack-icon"><img :src="item.picture_mobile"/></div>
        <div class="login-jack-num"><em class="icon-jack"></em><span>{{item.jackpot_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}} <em class="game-box-icon" ><img src="../assets/img/jackpotList-btn.png" @click.stop="_winning(item.id)"/></em></span></div>
        <div class="major" >
          {{item.jackpot_major_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}
        </div>
      </div>

    </div>
  </div>




  <div class="home-cover" v-if="isWin">
    <div class="major_cover-center">
      <div class="major_cover-title">
        <div class="major-gameTab">
          <span class="icon-slot"></span>
        </div>
        <span class="home-pop-close" @click.stop="_hideWin"></span>
      </div>
      <div class="major-list-title">
        <div>{{$t('home.t_1')}}</div>
        <div>{{$t('home.t_2')}}</div>
      </div>
      <div class="major-list">
        <div v-for="item in winningList"><span><em>{{item.bet_time}}</em><em>{{(item.user.username)}}</em></span><span>{{item.jackpot}}</span></div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
  import langs from './navs/lang'
    export default {
        name: "login",
      components:{langs},
      data(){
          return{
            isName:false,
            swiperOptions:{
              observer:true,//修改swiper自己或子元素时，自动初始化swiper
              observeParents:true,//修改swiper的父元素时，自动初始化swiper
              loop:true,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false
              }
            },
            adList:[],
            username:'',
            password:'',
            isConfirm:false,
            jack_list:[],
            logo:"",
            isCheck:false,
            inputtype:'password',
            isKey:true,
            winningList:[],
            isWin:false,
            isMajor:false,
          }
      },
      created:function(){
          let _self=this;
        document.onkeydown=function (e) {
          let key=window.event.keyCode;
          if(_self.isKey==true){
            if(key==13){
              _self._login();
            }
          }

        }
        let remember=_self.GLOBAL.fetch('remember');

        if(remember.length!=0){
          _self.isCheck=true;
          _self.username=remember.username;
          _self.password=remember.password;
        }else{
          _self.GLOBAL.delete('remember');
        }
          _self._banner();
          _self._config();
          _self._jackpot();

      },
      computed : {
        value2Computed: {
          get: function () {
            return this.username;
          },
          set: function (val) {
            this.username = val.toUpperCase();
          }
        },
      },
      methods:{
        _winning:function(id){
          let _self=this;
          if(_self.isMajor)
            return false;
          _self.isMajor=true;
          this._PublicFun.getData('1', 'get', 'jackpot/winning/'+id, {}, function (result) {
            if (result.data['status_code'] == 200) {
              _self.winningList=result.data['data'];
              _self.isWin=true;
              _self.isMajor=false;
            }else{
              Toast(result.data['message']);
              _self.isMajor=false;
            }
          })

        },
        _hideWin:function(){
          let _self=this;
          _self.isWin=false;
        },
        _select:function(e){
          let _self=this;
          if(e.target.checked==true){
            _self.isCheck=true;
          }else{
            _self.isCheck=false;
          }
        },
        _eye:function(){
          let _self=this;
          if(_self.inputtype=='password'){
            _self.inputtype='text';
          }else{
            _self.inputtype='password';
          }
        },
        _jackpot:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'jackpot/top', {}, function (result) {
            if(result.data['status_code']==200){
              _self.jack_list=result.data['data'];
            }
          })
        },
        _config:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'site/config', {}, function (result) {
            if(result.data['status_code']==200){
              _self.logo=result.data['data'].logo;
            }
          })
        },
        _banner:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'ad', {}, function (result) {
            if(result.data['status_code']==200){
              _self.adList=result.data['data'];
            }

          })
        },

        _login:function () {
          let _self=this;
          if(_self.username!='' && _self.password!=''){
            if(_self.isConfirm)
              return false;
            _self.isConfirm=true;
            this._PublicFun.getData('1', 'post', 'login', {'username':_self.username,'password':_self.password}, function (result) {
              if(result.data['status_code']==201){
                _self.GLOBAL.save('token',result.data['data']);
                if(_self.isCheck==true){
                  let remember={'username':_self.username,'password':_self.password};
                  _self.GLOBAL.save('remember',remember)
                }else{
                  _self.GLOBAL.delete('remember')
                }
                _self.isKey=false;
                _self.isConfirm=false;
                _self.$router.push({path:'/'})
              }else{
                Toast(result.data['message']);
                _self.isConfirm=false;
              }
            })

          }else {
            Toast(_self.$t('login.msg'))
          }

        }
      }
    }
</script>

<style scoped>
  @import "../assets/css/home.css";
  .login_page{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    background: url("../assets/img/cache.jpg") no-repeat center;
    background-size: 100% 100%;
    overflow-y: auto;
  }
  .login_title{
    display: flex;
    width: 100%;
    margin: 0 auto 10px;
    padding: 0;
    align-items:center ;
    justify-content: right;
    color: #000000;
  }
  .logo{
    display: block;
    margin: 10px auto;
    padding: 0;
    text-align: center;
    position: absolute;
    z-index: 99;
    left: 10px;
    top: 10px;
  }
  .logo img{
    height: 50px;
    width: auto;
  }
  .login-box{
    padding: 10px;
    margin: 0 auto;
    width: 90%;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 20px;
    min-height: 200px;
    max-width: 250px;
    position: absolute;
    top: 10px;
    right: 5%;
    border: 5px solid #FDFDFB;
    z-index: 99;

  }
  .login-from{
    border-radius: 15px;
    padding: 1px 0;
    background: #DDDDDD;
    position: relative;
    border: 1px solid #ffffff;
  }
  .form-control{
    margin: 0 auto;
    padding: 10px 20px 0 20px ;
    line-height: 25px;
    position: relative;


  }
  .form-control::before{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    border-bottom: 1px solid #ffffff;
    content: '';
  }
  .form-control:last-child::before{
    border-bottom: none;
  }
  .form-control input{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 40px;
    line-height: 40px;
    outline: none;
    border: none;
    color: #381236;
    font-size: 18px;
    background-color: transparent;
  }
  .form-control span{
    position: absolute;
    top: -10px;
    font-size: 13px;
    opacity: 0;
  }
  .remember,.eye{
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
    height: 25px;
    cursor: pointer;
  }
  .remember input[type=checkbox]{
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    cursor: pointer;
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    vertical-align: bottom;
    background-color: #fff;
    border: 2px solid #afafaf;
    box-shadow: 0 0 5px #bdbdbd;
    transition: all .4s;


  }
  .remember input[type=checkbox]:checked::after{
    font-family: 'icomoon','arial';
    content: "\e90f";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 23px;
    height: 23px;
    border-radius: 50%;
    text-align: center;
    line-height: 23px;
    color: #ffffff;
    font-size: 2rem;
    border: 2px solid #afafaf;
    border-color: #757575;
    background-color: #757575;
    box-shadow: 0 0 5px #bdbdbd;
  }
  .eye img{
    width: 25px;
    height: 25px;
  }
  .remember-tip{
    display: block;
    opacity: 1!important;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -30px!important;
    background: #333333da;
    box-shadow: 0 2px 5px #29292967;
    color: #ffffffd7;
    padding: 3px 0;
    border-radius: 5px;
    font-size: 85%;
    line-height: 20px;
    min-width: 110px;
    text-align: center;
    pointer-events: none;
    transition: opacity 1s ease-in-out;
  }
  .remember-tip:before{
    content: '';
    position: absolute;
    left: 50%;
    bottom: -7px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px 7px 0 7px;
    border-color: #333333da transparent transparent transparent;
  }
  .login_btn{
    width: 100%;
    border: 2px solid #f09c1a;
    background: linear-gradient(180deg, #f09c1a 25%, #feff83 100%);
    transition: all .1s ease-in-out;
    box-shadow: 0 0 10px #ffeb3b;
    margin: 20px 0 10px 0;
    font-size: 120%;
    line-height: 44px;
    text-align: center;
    font-weight: 500;
    border-radius: 100px;
    text-shadow: 0px 3px 5px rgba(0,0,0,0.29);
    color: #ffffff;
    cursor: pointer;
  }
  .login_carousel{
    display: inline-block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    position: relative;
    min-width: 250px;
  }
  .Carousel_img{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
  .Carousel_img img{
    width: 100%;
    height: auto;
  }
  .login_jack{
    width: 90%;
    max-width: 750px;
    padding: 15px 0;
    position: relative;
    margin: 140px auto 15px auto;
    background: linear-gradient(135deg, #fceabb 0%, #fccd4d 50%, #f8b500 51%, #fbdf93 100%);
    border: none;
    border-radius: 150% 35px;
    box-shadow: rgba(255,255,255,0.1) 0px 1px 1px 0px inset, rgba(50,50,93,0.25) 0px 50px 100px -20px, rgba(0,0,0,0.30) 0px 30px 60px -30px;
  }
  .login_jack-top{
    position: absolute;
    width: 100%;
    left: 0;
    top: -90px;
    height: 150px;
    background-size: 300px;
    z-index: 100;
    display: inline-block;
    background: url(../assets/img/jackpot-mult-box-top-V3.png) top center no-repeat;
    background-size: 400px;
    pointer-events: none
  }
  .login-jack-list{
    position: relative;
    padding: 15px 25px;
    z-index: 10;
    border-bottom: 0px solid #615a3d;
  }
  .login-jack-list:before{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    content: '';
    border-bottom: 1px solid #6c372f;
    width: 90%;

  }
  .login_jack:after{
    position: absolute;
    content: '';
    height: calc( 100% - 10px);
    width: calc( 100% - 10px);
    z-index: 0;
    left: 5px;
    top: 5px;
    background: radial-gradient(ellipse at center, #ac5544 0%, #432321 100%);
    border-radius: 33px;
    z-index: 0;
    box-shadow: 0 2px 10px #000 inset;
  }
  .jack-top{
    margin-top: 40px;
  }
  .login-jack-center{
    display: flex;
    width: 90%;
    margin: 0 auto;
    padding: 0;
    align-items: center;

  }
  .login-jack-icon{
    display: block;
    margin: 0;
    padding: 0;
    text-align: center;
    width: 25%;

  }

  .login-jack-icon img{
    width: 75px;
    height: auto;
  }
  .login-jack-num{
    padding: 0;
    display: flex;
    text-align: center;
    vertical-align: middle;
    position: relative;
    align-items: center;
  /*  width: 75%;*/
    padding-right: 30px;
  }
  .icon-jack{
    display: inline-block;
    padding: 5px 10px 7px 10px;
    min-width: 40px;
    text-align: center;
    font-size: initial;
    border-radius: 100px;
    background: #44210d;
    color: #e1be83;
  }
  .icon-jack:before{
    content: "\e96a";
    color: #e1be83;
    font-size: 22px !important;
    text-align: center !important;
    margin-right: 0 !important;
  }
  .login-jack-num span{
    background: -webkit-linear-gradient(#ffffe8, #daa156);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    font-size: 120%;
    line-height: normal;
    margin-bottom: 0;
    padding: 0 5px 0 15px;
    white-space: nowrap;
    font-weight: bold;
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue